import { presentLexError } from '@/lib/user-notice';
import { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = (location.state as { from?: { pathname: string } })?.from?.pathname || '/inicio';

  if (user) {
    navigate(from, { replace: true });
    return null;
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (!username.trim() || !password) {
      setError('Usuario y contraseña son obligatorios.');
      return;
    }
    setSubmitting(true);
    try {
      await login(username.trim(), password);
      navigate(from, { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Error al iniciar sesión.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="lex-auth-shell">
      <div className="lex-auth-page">
        <div className="lex-stack">
          <section className="lex-surface-card lex-card">
            <div className="lex-section-kicker" style={{ marginBottom: 10 }}>
              <i className="ri-scales-3-line" aria-hidden />
              Acceso móvil
            </div>
            <h1 style={{ margin: 0, fontSize: 30, lineHeight: 1.03, letterSpacing: '-0.05em', fontWeight: 900, color: 'var(--lex-on-surface)' }}>
              DUMAS
            </h1>
            <p style={{ margin: '12px 0 0', maxWidth: 300, fontSize: 14, lineHeight: 1.55, color: 'var(--lex-on-surface-variant)' }}>
              Entra a tu biblioteca legal, DOF y favoritos desde una sola interfaz móvil.
            </p>
          </section>

          <section className="lex-surface-card lex-card">
            <div className="lex-section-kicker" style={{ marginBottom: 8 }}>
              Identificación
            </div>
            <h2 className="lex-section-title" style={{ marginBottom: 14 }}>
              Iniciar sesión
            </h2>

            <form onSubmit={handleSubmit} className="lex-stack" style={{ gap: 12 }}>
              <div>
                <label htmlFor="username" className="lex-label">
                  Usuario
                </label>
                <input
                  id="username"
                  type="text"
                  autoComplete="username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  disabled={submitting}
                  className="lex-input"
                />
              </div>

              <div>
                <label htmlFor="password" className="lex-label">
                  Contraseña
                </label>
                <input
                  id="password"
                  type="password"
                  autoComplete="current-password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  disabled={submitting}
                  className="lex-input"
                />
              </div>

              {error ? <p style={{ margin: 0, color: 'var(--lex-danger)', fontSize: 14 }}>{presentLexError(error)}</p> : null}

              <button type="submit" className="lex-button-primary" disabled={submitting}>
                <i className={submitting ? 'ri-loader-4-line' : 'ri-login-box-line'} aria-hidden />
                {submitting ? 'Entrando…' : 'Entrar a DUMAS'}
              </button>
            </form>
          </section>

          <section className="lex-surface-card lex-card" style={{ paddingTop: 16, paddingBottom: 16 }}>
            <div className="lex-stack" style={{ gap: 10 }}>
              <Link to="/registro" style={{ color: 'var(--lex-primary)', fontWeight: 700, textDecoration: 'none' }}>
                Crear cuenta
              </Link>
              <Link to="/recuperar" style={{ color: 'var(--lex-on-surface-variant)', fontWeight: 700, textDecoration: 'none' }}>
                Recuperar contraseña
              </Link>
              <a
                href="https://dumas.solutions"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: 'var(--lex-on-surface-variant)', fontSize: 13, textDecoration: 'none' }}
              >
                Ir a dumas.solutions
              </a>
            </div>
          </section>
        </div>
      </div>
    </main>
  );
}
